<script lang="ts">
  import { onMount } from 'svelte';
  import { editorStore } from '../../../stores/editorStore';

  export let message: string;
  export let autoDismiss = true;
  export let dismissDelay = 5000;

  let visible = true;
  let timeoutId: number | null = null;

  function dismiss() {
    visible = false;
    editorStore.clearError();
  }

  onMount(() => {
    if (autoDismiss) {
      timeoutId = window.setTimeout(() => {
        dismiss();
      }, dismissDelay);
    }

    return () => {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
    };
  });
</script>

{#if visible && message}
  <div
    class="error-banner"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="error-content">
      <span class="error-icon" aria-hidden="true">⚠️</span>
      <span class="error-message">{message}</span>
      <button
        on:click={dismiss}
        class="dismiss-button"
        aria-label="Dismiss error"
      >
        ✕
      </button>
    </div>
  </div>
{/if}

<style>
  .error-banner {
    position: fixed;
    top: 5rem;
    right: 1rem;
    max-width: 400px;
    width: 90%;
    background: var(--color-error-bg, #f8d7da);
    border: 1px solid var(--color-error-border, #f5c6cb);
    border-radius: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1001;
    animation: slideIn 0.3s ease-out;
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .error-content {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem;
  }

  .error-icon {
    font-size: 1.25rem;
    flex-shrink: 0;
  }

  .error-message {
    flex: 1;
    color: var(--color-error-text, #721c24);
    font-size: 0.875rem;
    line-height: 1.4;
  }

  .dismiss-button {
    background: none;
    border: none;
    color: var(--color-error-text, #721c24);
    font-size: 1.25rem;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background 0.2s;
  }

  .dismiss-button:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  .dismiss-button:focus {
    outline: 2px solid var(--color-focus, #007bff);
    outline-offset: 2px;
  }
</style>
